import React, { Fragment } from 'react';
import ProjecaoMensalService from '../../../../lib/api/projecaoMensal/projecaoMensalService';
import TemplateParametro from '../shared/templateParametros/templateParametros';
import JurosSomadosIpca from './jurosSomadosIpca/jurosSomadosIpca';

class ProjecaoMensal extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelProjecaoMensal()
    {
        return ProjecaoMensalService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return ProjecaoMensalService.enviarParametrosAoEventGrid();
    }
    
    render() 
    {
        return (
            <Fragment>
                <JurosSomadosIpca></JurosSomadosIpca>
                <TemplateParametro
                    enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                    baixarExcelParametros={this.baixarExcelProjecaoMensal}
                    enviarExcelParametros={ProjecaoMensalService.enviarExcelParametros}
                    deletarExcelParametros={ProjecaoMensalService.deletarExcelParametros}
                    nomeDoArquivo='Parametro Projecao INCC e IPCA'
                ></TemplateParametro>
            </Fragment>
        );
    }
}

export default ProjecaoMensal